import styled from '@emotion/styled';
import React from 'react';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  /** Inline style for this option — e.g. a `fontFamily` preview. Also mirrored
   *  onto the closed control when this option is the selected one. */
  style?: React.CSSProperties;
}

interface SelectFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  options: SelectOption[];
}

const SelectField: React.FC<SelectFieldProps> = ({ value, onChange, options }) => {
  const selectedStyle = options.find((o) => o.value === (value ?? ''))?.style;
  return (
    <Select style={selectedStyle} value={value ?? ''} onChange={(e) => onChange(e.target.value)}>
      {options.map((o) => (
        <option key={o.value} value={o.value} disabled={o.disabled} style={o.style}>
          {o.label}
        </option>
      ))}
    </Select>
  );
};

export default SelectField;

const Select = styled.select`
  width: 100%;
  min-width: 0;
  /* Asymmetric right padding reserves the strip the UA paints its dropdown
     arrow into — the arrow sits inside the padding box, so without it a long
     label runs underneath the arrow instead of ellipsizing before it. */
  padding: 4px 0 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #ffffff;
  outline: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:focus {
    border-color: #9ca3af;
  }
`;
